import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export default function Reveal({
  children,
  delay = 0,
  y = 28,
  className = "",
  once = true,
}) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, amount: 0.15 }}
      transition={{ duration: 0.8, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function SectionHeading({ eyebrow, title, align = "left" }) {
  return (
    <div className={align === "center" ? "text-center" : ""}>
      <Reveal>
        <p className="eyebrow mb-4 flex items-center gap-3" data-testid="section-eyebrow">
          {align === "left" && <span className="inline-block h-px w-10 bg-amber-600/70" />}
          {eyebrow}
          {align === "center" && <span className="inline-block h-px w-10 bg-amber-600/70" />}
        </p>
      </Reveal>
      <Reveal delay={0.08}>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold uppercase leading-[0.95] tracking-tight text-stone-900">
          {title}
        </h2>
      </Reveal>
    </div>
  );
}
